import * as React from 'react';
import { Route, Switch } from 'react-router';

import '@servicetitan/anvil-fonts/dist/css/anvil-fonts.css';
import '@servicetitan/design-system/dist/system.min.css';

import { ErrorPage } from 'src/core/components/error-page/error-page';
import { PrivateRoute } from 'src/routes';
import { UnsubscribePageContainer } from 'src/marketing/components/unsubscribe-page/subscription-page';
import { OptInPage } from 'src/marketing/components/opt-in-page/opt-in-page';
import { OptOutPageContainer } from 'src/marketing/components/opt-out-page/opt-out-page';

export const MarketingRoutes: React.FC = () => (
    <Switch>
        <Route
            exact
            path="/marketing/expired-link"
            component={() => <ErrorPage type="expired-link" />}
        />
        <Route exact path="/marketing/not-found" component={() => <ErrorPage type="not-found" />} />
        <PrivateRoute
            allowAnonUnsubscribe
            exact
            path="/marketing/unsubscribe/:emailId/(version)?/:version?"
            component={UnsubscribePageContainer}
        />
        <PrivateRoute
            allowAnonUnsubscribe
            exact
            path="/marketing/optin/:emailId"
            component={OptInPage}
        />
        <PrivateRoute
            allowAnonUnsubscribe
            exact
            path="/marketing/optout/:emailId/(version)?/:version?"
            component={OptOutPageContainer}
        />
        <Route component={() => <ErrorPage type="not-found" />} />
    </Switch>
);
